import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-2 pl-2" }
const _hoisted_2 = { class: "col-1 pt-2" }
const _hoisted_3 = { class: "col-2" }

import ToggleSwitch from '@/components/ToggleSwitch.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationSettingRow',
  props: {
    title: {},
    keyName: {},
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "text-form pr-3 pt-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "2" }, {
        default: _withCtx(() => [
          _createElementVNode("h6", _hoisted_1, _toDisplayString(props.title), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "10",
        class: "d-flex",
        style: {"position":"relative"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelValue.value, (bool, key) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h6", null, _toDisplayString(_unref(i18n).global.t(`pages.accounts.form.notificationSettings.${__props.keyName}.${key}`)), 1)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(ToggleSwitch, {
                  modelValue: modelValue.value[key],
                  "onUpdate:modelValue": ($event: any) => ((modelValue.value[key]) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})